<template>
    <div>
        <div>
            <el-form ref="teacher" :model="$parentInfo.dialog_CreateTeacherPlan.teacher"
                     label-width="70px">
                <el-form-item label="学科">
                    <el-select
                            v-model="$parentInfo.dialog_CreateTeacherPlan.subject_id"
                            placeholder="请选择学科" style="width: 200px">
                        <el-option
                                v-for="item in $parentInfo.subjects"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="学科">
                    <el-select
                            v-model="$parentInfo.dialog_CreateTeacherPlan.grade_id"
                            placeholder="请选择学科" style="width: 200px">
                        <el-option
                                v-for="item in $parentInfo.grade_id"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="教案名" prop="name">
                    <el-input v-model="$parentInfo.dialog_CreateTeacherPlan.name" placeholder="请输入教案名" style="width: 200px"></el-input>
                </el-form-item>

            </el-form>
        </div>
        <div class="text-right">
            <el-button @click="handleStoreTeacherPlan" :loading="$parentInfo.dialog_CreateTeacherPlan.button_loading">保存
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_CreateNewTeacherPlan",
        data() {
            return {
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            handleStoreTeacherPlan() {
                this.$confirm('确认创建?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parentInfo.dialog_CreateTeacher.button_loading = true;
                    this.$wApi.send(this.$parentInfo.path, 'store_teacherPlan', {
                        'name': this.$parentInfo.dialog_CreateTeacherPlan.name,
                        'grade_id': this.$parentInfo.dialog_CreateTeacherPlan.grade_id,
                        'subject_id': this.$parentInfo.dialog_CreateTeacherPlan.subject_id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
        }
    }
</script>
